import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=8c6da05c&scoped=true&"
var script = {}
import style0 from "./contacts.vue?vue&type=style&index=0&id=8c6da05c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6da05c",
  null
  
)

export default component.exports